import CouponRange from './CouponRange';

export default CouponRange;
